module.exports = __webpack_public_path__ + "img/h2p-rulebook.e8ca77db.png";